import './Location.css';

const mapUrl =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.3734167683842!2d78.877956!3d11.233917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bab1b7989ccb8e7%3A0x6e423eb2e015f94f!2sDhanalakshmi%20Srinivasan%20Marriage%20Hall!5e0!3m2!1sen!2sus!4v1768117069377!5m2!1sen!2sus';
const mapsLink =
  'https://maps.app.goo.gl/LgU4E1PSotoy5TCe7';

function Location() {
  return (
    <main className="location">
      <div className="location-inner">
        <div className="location-card">
          <div className="location-icon" aria-hidden="true">
            <svg viewBox="0 0 48 48" role="img" aria-hidden="true">
              <path
                d="M24 6c-7.2 0-13 5.8-13 13 0 9.9 13 23 13 23s13-13.1 13-23c0-7.2-5.8-13-13-13zm0 18.5c-3 0-5.5-2.5-5.5-5.5s2.5-5.5 5.5-5.5 5.5 2.5 5.5 5.5-2.5 5.5-5.5 5.5z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              />
            </svg>
          </div>
          <h3 className="location-title">Location</h3>
          <p className="location-name">Dhanalakshmi Srinivasan Marriage Hall, Perambalur</p>
          <div className="location-map">
            <iframe
              title="Map location"
              src={mapUrl}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <a
            className="location-button"
            href={mapsLink}
            target="_blank"
            rel="noreferrer"
          >
            <span className="location-button-icon" aria-hidden="true">
              <svg viewBox="0 0 48 48" role="img" aria-hidden="true">
                <path
                  d="M24 6c-7.2 0-13 5.8-13 13 0 9.9 13 23 13 23s13-13.1 13-23c0-7.2-5.8-13-13-13zm0 18.5c-3 0-5.5-2.5-5.5-5.5s2.5-5.5 5.5-5.5 5.5 2.5 5.5 5.5-2.5 5.5-5.5 5.5z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </span>
            <span className="location-button-text">Open in Maps</span>
          </a>
        </div>
      </div>
    </main>
  );
}

export default Location;
